import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FlyCommonModule} from "fly-common/fly-common.module";
import {SharedModule} from "../shared/shared.module";
import {ProductSeriesDisplayComponent} from "./product-series-display.component";

@NgModule({
	imports: [
		CommonModule,
		FlyCommonModule,
		SharedModule,
	],
	declarations: [
		ProductSeriesDisplayComponent,
	],
	exports: [
		ProductSeriesDisplayComponent,
	],
})
export class DeviceManagementCommonModule {}
